// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2IHXy","left":"StickyBox_left__38vAQ","right":"StickyBox_right__28MfM"};